import { createSlice } from '@reduxjs/toolkit';

interface ILoader {
  loading: boolean;
}

const initialStateLoader: ILoader = {
  loading: false,
};

export const loaderReduce = createSlice({
  name: 'loader',
  initialState: initialStateLoader,
  reducers: {
    showLoader: (state) => {
      state.loading = true;
    },
    hideLoader: (state) => {
      state.loading = false;
    },
  },
});

export const { showLoader, hideLoader } = loaderReduce.actions;
export default loaderReduce.reducer;
